import Select from "react-select"
import React, { useEffect, useState } from "react"
import { getSystemOptions } from "common/SelectOptions/systemOptions";

const BenchmarkingFilters = ({
  filteredSystems,
  applyFilters
}) => {
  const [systemOptions, setSystemOptions] = useState([]);
  const [selectedSystems, setSelectedSystems] = useState(filteredSystems);

  useEffect(() => {
    const fetchOptions = async () => {
      setSystemOptions(await getSystemOptions());
    };
    fetchOptions();
  }, []);

  return (
    <div>
      {/* Filter by Location */}
      <div className="d-flex my-2">
        <div className="d-flex align-items-center">
          <i className="mdi mdi-map-marker-outline me-1" />
          <h6 className="mb-0">Systems:</h6>
        </div>
        <div className="ms-2" style={{ width: "100%" }}>
          <Select
            isMulti
            options={systemOptions}
            defaultValue={selectedSystems}
            className="basic-single"
            classNamePrefix="select"
            placeholder="Select systems"
            onChange={options => setSelectedSystems(options)}
          />
        </div>
      </div>

      {/* Apply Filters Button */}
      <div className="d-flex" style={{ justifyContent: "center" }}>
        <button
          className="btn btn-success common-button"
          style={{ width: "90%" }}
          onClick={()=>
            applyFilters(
              selectedSystems
            )}
        >
          Apply
        </button>
      </div>
    </div>
  )
}

export default BenchmarkingFilters
